import { ConstraintSpec } from '../../../process/capability-spec/constraints/constraint-spec'
import { ConstraintConf } from '../../workcenters/capability/constraints/constraint-conf'

export class WorkStationConfiguration {
  constructor(
    public spec: ConstraintSpec = new ConstraintSpec(),
    public possibleValues: string[] = [],
    public activeConf: ConstraintConf = new ConstraintConf()
  ) {}
}
